import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { VideoPortalUser } from '../auth/video-portal-user.model';
import { map, take, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class UsageReportsAuthGuardService implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.userInfo != null) {
            return this.isAuthorised(this.authService.userInfo);
        } else {
            return this.authService.userInfoSubject.pipe(
                filter(user => user !== null),
                take(1),
                map(user => this.isAuthorised(user)),
                catchError(() => {
                    this.router.navigate(['/error']);
                    return of(false);
                })
            );
        }
    }

    private isAuthorised(user: VideoPortalUser | null): boolean {
        const authorized = !!user &&
                           user.hasAdminRole &&
                           user.roles.some(r => r === 'jjr');

        if (!authorized) {
            this.router.navigate(['/home']);
            return false;
        }
        return true;
    }
}
